<template>
    <div>

        <van-row >
            <van-divider />
            <van-col span="9" offset="1">
                <span >明细占比:{{sortName}}</span>
            </van-col>
        </van-row>
        <van-row>
            <canvas :id="viewId" ></canvas>
        </van-row>

    </div>

</template>

<script>
    import F2 from "@antv/f2/lib/index-all"
    import * as MyApi from '@/api/URLApiAddr.js'
    import * as FinUtil from '@/common/utils/finUtil.js'
    import * as BusiConsts from '@/common/BusiConsts.js'
    export default {
        name: "FinSortDetail",
        props:{
            monthDate: {
                type: String,
                default: '',
            },
            yearDate: {
                type: String,
                default: '',
            },
            rangeDate:{
                type: Object
            },
            viewId: {
                type: String,
                default: 'finSortDetailPercent',
            },
            sortName:{
                type: String,
                default: '',
            },
            sort:{
                type: Number
            }
        },
        data() {
            return {
                isPlain: false,
                payColor:'#E1B4AF',
                incomeColor:'#70cdd0',
                mainColor:'#E1B4AF',
                chart: undefined

            };
        },
        watch: {
            sort() {
                this.drawData()
            },
            rangeDate() {
                this.drawData()
            },
            monthDate() {
                this.drawData()
            },
            yearDate() {
                this.drawData()
            }
        },
        mounted(){
            this.drawData();
        },
        methods: {

            drawData() {
                if(this.chart){
                    this.chart.destroy()
                }
                let params = {
                    sort: this.sort
                }
                if(this.monthDate && this.monthDate != ''){
                    params.month = this.monthDate
                }
                if(this.rangeDate && this.rangeDate != ''){
                    params.startDate = this.rangeDate.startDate
                    params.endDate = this.rangeDate.endDate
                }
                if(this.yearDate && this.yearDate != ''){
                    params.year = this.yearDate
                }

                let viewId = this.viewId;
                let thiz = this;
                this.$axios.post(MyApi.QRY_FIN_SORT_DETAIL_PERCENT,params/*,options*/)
                    .then((response) =>  {
                        let code = response.code;
                        let data = response.data;
                        debugger
                        if(code == 200){
                            //计算占比
                            let map = FinUtil.calculatePercent(data,'money','type');
                            let viewHeight = (window.innerWidth*3/4) + 60
                            const chart = new F2.Chart({
                                id: viewId,
                                width:window.innerWidth,
                                height:viewHeight,
                                pixelRatio: window.devicePixelRatio,
                                padding: [40, 'auto', 'auto', 'auto']
                            });
                            chart.source(data);
                            chart.coord('polar', {
                                transposed: true,
                                radius: 0.9,
                                innerRadius: 0.5
                            });
                            chart.axis(false);
                            chart.legend('type', {
                                position: 'bottom',
                                align: 'center',
                                itemFormatter: function itemFormatter(val) {
                                    return val + '  ' + map[val]+'%';
                                }
                            });
                            chart.tooltip(false);
                            chart.guide()
                                .html({
                                    position: [ '50%', '50%' ],
                                    html: '<div style="text-align: center;width:150px;height: 50px;">\n      <p style="font-size: 12px;color: #999;margin: 0" id="title"></p>\n      <p style="font-size: 18px;color: #343434;margin: 0;font-weight: bold;" id="money"></p>\n      </div>'
                                });
                            chart.interval()
                                .position('const*money')
                                .adjust('stack')
                                .color('type', [ '#00BFFF','#F04864', '#E1B4AF','#FF7F00','#836FFF','#1890FF', '#13C2C2', '#2FC25B', '#FACC14','#FF4500' ]);
                            chart.pieLabel({
                                sidePadding: 30,
                                activeShape: true,
                                label1: function label1(data) {
                                    return {
                                        text: '￥' + data.money,
                                        fill: '#343434',
                                        fontWeight: 'bold'
                                    };
                                },
                                label2: function label2(data) {
                                    return {
                                        text: data.type,
                                        fill: '#999'
                                    };
                                },
                                onClick: function onClick(ev) {
                                    const data = ev.data;
                                    if (data) {
                                        debugger;
                                        let res = {}
                                        res["detail"] = data.sort
                                        //res["finType"] = BusiConsts.FIN_TYPE_PAY
                                        thiz.$emit('getParData', res)

                                        // $('#title').text(data.type);
                                        // $('#money').text(data.money);
                                    }
                                },
                                triggerOn: 'click'
                            });
                            this.chart = chart
                            chart.render();
                        }

                    })
                    .catch((err) => {
                        debugger
                        console.log(err)
                        this.$toast.fail("请求异常,请稍后再试"+err);
                    })

            },
            refreshType(flag,finType) {
                if(flag){
                    this.mainColor = this.incomeColor
                }else{
                    this.mainColor = this.payColor
                }
                this.isPlain = flag
                this.drawData(finType)
            }
        }
    }
</script>

<style scoped>

</style>
